<template>
  <v-layout wrap>
    <v-flex
      xs12
      sm12
      v-for="bid in loadBids"
      v-bind:key="bid._id"
      class="list-section pa-2 mx-3 mb-0 mb-3"
      v-if="bid.jobId != null"
    >
      <div>
        <v-btn class="right" icon @click="deleteModal(bid._id)"><v-icon color="red">delete</v-icon></v-btn>
        <div class="right mt-2" v-if="bid.jobId.is_vip_featured == true">
          <v-chip color="orange" dark small><v-icon color="white"></v-icon>Featured</v-chip>
        </div>
        <span class="bold" v-if="bid.jobId.title"><b>Job Title:</b> {{bid.jobId.title}}</span>
      </div>

      <div>        
        <p><div v-html="bid.jobId.description"></div></p>
      </div>

      <div>
        <h4>Time Frame: <span class="font-weight-regular">{{bid.jobId.timeFrame}}</span></h4>
        <h4><strong>Primary Job Location: </strong><span class="font-weight-regular">{{bid.jobId.location.locationName}}</span></h4>
        <h4 v-if="bid.jobId.is_vip_featured == true && (bid.sonko.locationOne || bid.sonko.locationTwo || bid.sonko.locationThree || bid.sonko.locationFour)"><strong>Additional Preferred Expert Locations: </strong>
          <span class="font-weight-regular" v-if="bid.sonko.locationOne">{{bid.sonko.locationOne.locationName}}</span>
          <span class="font-weight-regular" v-if="bid.sonko.locationTwo">: {{bid.sonko.locationTwo.locationName}}</span>
          <span class="font-weight-regular" v-if="bid.sonko.locationThree">: {{bid.sonko.locationThree.locationName}}</span>
          <span class="font-weight-regular" v-if="bid.sonko.locationFour">: {{bid.sonko.locationFour.locationName}}</span>
        </h4>
        <h4>Category: <span class="font-weight-regular">{{bid.jobId.category}}</span></h4>
        <h4 v-if="bid.jobId.active == true && bid.jobId.assigned == false && bid.jobId.expired==false">Job Status: <span style="color: green;" class="font-weight-bold">Available</span></h4>
        <h4>Sonko Name: <span class="font-weight-regular">{{bid.sonko.firstName}} {{bid.sonko.lastName}}</span></h4>
        <h4 v-if="bid.sonko.locationOne && bid.jobId.is_vip_featured != true">Location: <span class="font-weight-regular">{{bid.sonko.locationOne.locationName}}</span></h4>
        <h4>Posted On: <span class="font-weight-regular">{{bid.jobId.createdAt | moment("DD MMMM YYYY") }}</span></h4>
      </div>

      <!-- <div>
        <p>
          Time Frame: {{bid.jobId.timeFrame}}
          <br>
          Category: {{bid.jobId.category}}
        </p>
      </div>
      <h4 v-if="bid.jobId.active == true && bid.jobId.assigned == false && bid.jobId.expired==false">Job Status: <span style="color: green">Available</span></h4>
      <div>
        Sonko Name: {{bid.sonko.firstName}} {{bid.sonko.lastName}}
        <br>
        Location: {{bid.sonko.locationOne.locationName}}
        <br>
        Posted On: {{bid.jobId.createdAt | moment("DD MMMM YYYY") }}
      </div> -->
      <div>
        <v-btn flat color="btnColor" :to="`/expert/job/details/${bid.jobId._id}`">More Details</v-btn>
        <span v-if="bid.jobId.expired == true || bid.jobId.status == 'expired'" style="color: red" class="right">Expired</span>
        <span v-else-if="bid.jobId.active == true && bid.jobId.assigned == true" style="color: red" class="right">Assigned</span>
        <span v-else-if="bid.jobId.active == false" style="color: red" class="right">Job Unavailable</span>
        <span v-else style="color: green" class="right">
          Bid Submitted; wait on Job Assignment
        </span>
      </div>
    </v-flex>

    <!-- delete modal -->
    <v-dialog v-model="deleteDialog" max-width="750px">
      <v-card>
        <v-toolbar color="primary" flat dense dark>
          <v-toolbar-title class="title">Delete Bid</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn class="mx-0" icon @click.native="deleteDialog = false">
            <v-icon color="white">clear</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm12 class="experience">Are you sure you want to delete this bid?</v-flex>

              <v-flex xs6>
                <v-btn color="red" dark :loading="loader" @click="deleteBid">
                  <v-icon left>delete</v-icon>Delete
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of delete modal -->
    <v-pagination class="ml-2 mt-2" v-if="bids.length>=1"
        v-model="currentPage"
        :length="Math.ceil(bids.length/perPage)"
    ></v-pagination>
  </v-layout>
  
</template>


<script>
export default {
  name: "AssignedJobsComponent",
  props: {
    bids: {
      type: Array
    }
  },
  computed: {
    loadBids() {
      return this.bids.slice((this.currentPage*this.perPage - this.perPage), ((this.currentPage*this.perPage - this.perPage)+this.perPage))
    }
  },
  data() {
    return {
      deleteDialog: false,
      id: null,
      loader: false,
      currentPage: 1,
      perPage: 10
    }
  },
  methods: {
    deleteModal(id) {
      this.id = id;
      this.deleteDialog = true;
    },
    deleteBid() {
      const id = this.id;
      const self = this;
      self.loader = true;
      this.$store
      .dispatch("remove", "/engagement/delete/" + id)
      .then(res => {
        location.reload();
      });
    }
  }
};
</script>

<style scoped>
.bold {
  font-weight: bold;
  color: orange;
}
</style>

